module.exports = __webpack_public_path__ + "static/img/cp04.eb8fe08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cp04.png
// module id = 7xnN
// module chunks = 1